export default __webpack_public_path__ + "static/media/plain-sticker-F.32f8a021.png";